import { faEye, faPaperPlane } from "@fortawesome/pro-regular-svg-icons";
import { faExclamationTriangle, faHeart, faUserAlt } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo } from "react";
import { Popup } from "semantic-ui-react";

export const NotifyNotificationsMetaStatType = {
  NotificationsDelivered: "NotificationsDelivered",
  NotificationsFailed: "NotificationsFailed",
  Subscribers: "Subscribers",
  Views: "Views",
  Likes: "Likes",
} as const;
type NotifyNotificationsMetaStatType =
  (typeof NotifyNotificationsMetaStatType)[keyof typeof NotifyNotificationsMetaStatType];

export function NotifyNotificationsMetaStat({ type, value }: { type: NotifyNotificationsMetaStatType; value: number }) {
  const icon = useMemo(() => {
    const iconTable = {
      [NotifyNotificationsMetaStatType.NotificationsDelivered]: faPaperPlane,
      [NotifyNotificationsMetaStatType.NotificationsFailed]: faExclamationTriangle,
      [NotifyNotificationsMetaStatType.Subscribers]: faUserAlt,
      [NotifyNotificationsMetaStatType.Views]: faEye,
      [NotifyNotificationsMetaStatType.Likes]: faHeart,
    };
    return iconTable[type];
  }, [type]);

  const tooltip = useMemo(() => {
    const tooltipTable = {
      [NotifyNotificationsMetaStatType.NotificationsDelivered]: "Notifications delivered",
      [NotifyNotificationsMetaStatType.NotificationsFailed]: "Notifications failed to deliver",
      [NotifyNotificationsMetaStatType.Subscribers]: "Subscribers",
      [NotifyNotificationsMetaStatType.Views]: "Views",
      [NotifyNotificationsMetaStatType.Likes]: "Likes",
    };
    return tooltipTable[type];
  }, [type]);

  const valueWithCommas = Intl.NumberFormat("en-US").format(value);

  return (
    <Popup
      trigger={
        <div className='tw-flex tw-items-center tw-gap-1 tw-text-text-hint'>
          <FontAwesomeIcon icon={icon} />
          <span className='tw-font-semibold tw-text-text-hint'>{valueWithCommas}</span>
        </div>
      }
      inverted
    >
      {tooltip}
    </Popup>
  );
}
